const columnClasses = {
    colNormal: "col-sm-6 text_align_right",
    colDesk1Mob2: "col-sm-6 order-2 order-sm-1",
    colDesk2Mob1: "col-sm-6 order-1 order-sm-2"
};

export {columnClasses};